/*
Usage: 
  <skio-cart-upsell item='{{ item | json | escape }}' line='{{ forloop.index }}'></skio-cart-upsell>
  <script src="{{ 'skio-cart-upsell.js' | asset_url }}" type="module"></script>
  
  May want to include above module globally if element is used in cart drawer
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js'

const skioCartStyles = css`
  .skio-cart-upsell {
    margin-top: 10px;
    width: 100%;
    
    background: transparent;
    border: 1px solid black;
    border-radius: 0;
    cursor: pointer;
    max-width: 300px;
  }

  .skio-plan-picker {
    display: flex;
    gap: 1rem;
    padding: 0;
    border: 0;
    /* font-size: 15px; */
    color: black;
    /* width: 100%; */
    /* margin-bottom: 1rem; */
    font-family: "Founders Grotesk Mono";
    flex-direction: column;
    margin-top: 10px;
  }

  .sr-only {
    position: absolute;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }

  .group-container {
    display: block;
    position: relative;
    background-color: transparent;
    color: #000;
    opacity: 0.5;
  }

  .group-container--selected {
    background-color: transparent;
    color: #000;
    opacity: 1;
    font-weight: bold;
  }

  .group-input {
    position: absolute;
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .group-input:focus-visible ~ .group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
  }

  .group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }

  .group-topline {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
  }

  .group-container--selected .group-topline {
    font-weight: 300;
  }

  .skio-radio__container {
    display: flex;
    color: #000;
  }

  .group-container--selected .skio-radio__container {
    color: #000;
  }

  .skio-radio {
    transform-origin: center;
    opacity: 0;
    transform: scale(0);
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .group-label:hover .skio-radio {
    opacity: 0.75;
    transform: scale(1);
  }

  .group-container--selected .group-label .skio-radio {
    opacity: 1;
    transform: scale(1);
  }

  .group-title {
    width: 100%;
    max-width: 100%;
    line-height: 1.5;
    text-transform: uppercase;
  }

  .group-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    opacity: 1;
    width: auto;
    max-height: 1000px;
    transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: uppercase;

    display: none;
  }

  .group-content.margin-left {
    margin-left: 25px;
  }

  /* Hide frequency if not selected */
  .group-container:not(.group-container--selected) .group-content {
    pointer-events: none;
    opacity: 0;
    max-height: 0;
    visibility: hidden;
  }

  .selling-plan-dropdown {
    font-family: "Founders Grotesk Mono";
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: flex;
    align-items: center;
    gap: 5px;
    width: fit-content;
    margin-top: 5px;
    padding: 13px 30px 13px 10px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px top 50%;
    background-size: 16px;
    border: 1px solid #ccc;
    border-radius: 2px;
    font-size: 14px;
    color: #000;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .selling-plan-dropdown-label {
    color: #000;
    font-weight: 300;
  }

  .selling-plan-dropdown--one {
    background-image: none;
    pointer-events: none;
    background: transparent;
  }
`

export class SkioCartUpsell extends LitElement {
  static styles = skioCartStyles

  static properties = {
    item: { type: Object },
    line: { type: Number },

    product: { type: Object },
    selectedVariant: { type: Object },
    key: { type: String },

    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},

    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},

    discount_format: { type: String },

    moneyFormatter: {},

    currency: { type: String },
  }

  constructor() {
    super()

    this.item = null
    this.line = null

    this.product = null
    this.selectedVariant = null

    this.skioSellingPlanGroups = null
    this.availableSellingPlanGroups = null

    this.selectedSellingPlanGroup = null
    this.selectedSellingPlan = null

    this.discountFormat = 'percent'

    this.currency = 'USD'
    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.currency,
    })
  }

  radioTemplate() {
    return html`
      <div class="skio-radio__container">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#000" stroke-width="1"></circle>
          <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
        </svg>
      </div>
    `
  }

  groupContent(group) {
    return html`
      <div class="group-content">
        <span class="selling-plan-dropdown-label">Deliver:</span>
        ${this.sellingPlanDropdown(group)}
      </div>
    `
  }

  sellingPlanDropdown(group) {
    return html`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(group).length == 1 ? 'selling-plan-dropdown--one' : ''}"
        @change=${e => {
          this.selectSellingPlan(e.target.value)
        }}
        @click=${e => e.stopPropagation()}
      >
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html` <option ?selected=${group.selected_selling_plan?.id === selling_plan.id} value=${selling_plan.id}>${selling_plan.name}</option> `
            )
          : ''}
      </select>
    `
  }

  getAvailableSellingPlans(group) {
    let availableSellingPlans = group.selling_plans.filter(selling_plan =>
      this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
    )

    return availableSellingPlans
  }

  radioButtons = () => {
    return html`
      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-cart-upsell-legend">
        <legend id="skio-cart-upsell-legend" class="sr-only">Select purchase option</legend>

        <!-- One-time purchase option -->
        <div
          class="group-container group-container--one-time ${!this.selectedSellingPlan ? 'group-container--selected' : ''}"
          @click=${() => this.selectOneTime()}
        >
          <input
            id="one-time-${this.key}"
            class="group-input"
            name="skio-group-${this.key}"
            type="radio"
            value="One time purchase"
            ?checked=${!this.selectedSellingPlan}
            @change=${() => this.selectOneTime()}
          />

          <label class="group-label" for="one-time-${this.key}">
            <div class="group-topline">
              ${this.radioTemplate()}
              <div class="group-title">Einmaliger Kauf</div>
            </div>
          </label>
        </div>

        <!-- Subscription option -->
        ${this.availableSellingPlanGroups?.length > 0 ? html`
          <div class="group-container ${this.selectedSellingPlan ? 'group-container--selected' : ''}">
            <input
              id="subscription-${this.key}"
              class="group-input"
              name="skio-group-${this.key}"
              type="radio"
              value="subscription"
              @change=${() => this.selectSubscription()}
              ?checked=${!!this.selectedSellingPlan}
            />

            <label class="group-label" for="subscription-${this.key}">
              <div class="group-topline">
                ${this.radioTemplate()}
                <div class="group-title">
                  Monatlich abonnieren
                </div>
              </div>
              ${this.selectedSellingPlan ? this.groupContent(this.selectedSellingPlanGroup) : ''}
            </label>
          </div>
        ` : ''}
      </fieldset>
    `
  }

  frequencyDropdown = () => {
    return html`
      <select class="frequency-dropdown" @change=${e => this.selectSellingPlan(e.target.value)} @click=${e => e.stopPropagation()}>
        ${this.availableSellingPlanGroups
          ? this.availableSellingPlanGroups.map(
              (group, index) =>
                html`
                  <optgroup label="${group.name}">
                    ${group
                      ? group.selling_plans.map(selling_plan => html` <option value="${selling_plan.id}" .selected=${selling_plan.id == this.selectedSellingPlan?.id}>${selling_plan.name}</option> `)
                      : ''}
                  </optgroup>
                `
            )
          : ''}
      </select>
    `
  }

  selectOneTime = () => {
    this.selectedSellingPlanGroup = null
    this.selectedSellingPlan = null
    this.updateLineItem()
  }

  selectSubscription = () => {
    if (this.availableSellingPlanGroups?.length > 0 && !this.selectedSellingPlan) {
      // Select the first available selling plan if none is selected
      const firstGroup = this.availableSellingPlanGroups[0]
      this.selectedSellingPlanGroup = firstGroup
      this.selectedSellingPlan = firstGroup.selected_selling_plan
    }
    this.updateLineItem()
  }

  changeFrequency = () => {
    return html`
      <select class="skio-cart-upsell" skio-cart-upsell="${this.key}" @change=${e => this.selectSellingPlan(e.target.value)}>
        ${!this.product.requires_selling_plan
          ? html`
              <optgroup label="One Time Purchase">
                <option value="">One-time</option>
              </optgroup>
            `
          : ''}
        ${this.availableSellingPlanGroups
          ? this.availableSellingPlanGroups.map(
              (group, index) =>
                html`
                  <optgroup label="${group.name} (Save ${this.discount(group.selected_selling_plan).percent})">
                    ${group
                      ? group.selling_plans.map(selling_plan => html` <option value="${selling_plan.id}" .selected=${selling_plan.id == this.selectedSellingPlan?.id}>${selling_plan.name}</option> `)
                      : ''}
                  </optgroup>
                `
            )
          : ''}
      </select>
    `
  }

  render() {
    if (!this.item || !this.product || !this.selectedVariant) return
    return this.radioButtons()
  }

  updated = changed => {
    if (changed.has('item') && this.item) {
      this.fetchProduct(this.item.handle)
    }

    if (changed.has('product') && this.product) {
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(selling_plan_group => selling_plan_group.app_id === 'SKIO')

      this.selectedVariant = this.product.variants.find(variant => variant.id == this.item.variant_id)

      if (this.item.selling_plan_allocation) {
        this.selectedSellingPlanGroup = this.skioSellingPlanGroups.find(group => group.selling_plans.find(selling_plan => selling_plan.id == this.item.selling_plan_allocation.selling_plan.id))
        this.selectedSellingPlan = this.selectedSellingPlanGroup.selling_plans.find(selling_plan => selling_plan.id == this.item.selling_plan_allocation.selling_plan.id)
      }
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups.length) {
        //update each group with a default selected_selling_plan

        this.availableSellingPlanGroups.forEach(group => {
          group.selected_selling_plan = group.selling_plans[0]
        })
      }
    }

    if (changed.has('selectedSellingPlan') && this.product) {
      this.updateLineItem()
    }
  }

  log = (...args) => {
    args.unshift('%c[skio cart upsell]', 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error = (...args) => {
    args.unshift('%c [skio cart upsell]', 'color: #ff0000')
    console.error.apply(console, args)
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart_form',
        section: document.getElementById('cart_form').dataset.id,
        selector: '.cart__item-list',
      },
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  updateLineItem() {
    if (!this.line || !this.item) return
    if (this.item.selling_plan_allocation?.selling_plan?.id == this.selectedSellingPlan?.id) return

    let data

    if (this.selectedSellingPlan) {
      data = JSON.stringify({
        line: this.line,
        quantity: this.item.quantity,
        selling_plan: this.selectedSellingPlan ? this.selectedSellingPlan?.id : null,
        properties: {
          'Subscription Discount': this.discount(this.selectedSellingPlan).percent,
        },
      })
    } else {
      data = JSON.stringify({
        line: this.line,
        quantity: this.item.quantity,
        selling_plan: null,
        properties: {
          'Subscription Discount': null,
        },
      })
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
      .then(response => response.text())
      .then(cart => {
        if (Shopify.theme.jsCart !== 'undefined' && window.location.href.includes('/cart')) {
          Shopify.theme.jsCart.updateView(JSON.parse(cart), this.line)
        }

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView()
        }

        // if (window.location.href.includes('/cart')) {
        //   const parsedState = JSON.parse(cart);
        //   this.getSectionsToRender().forEach((section => {
        //     const elementToReplace =
        //       document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        //     elementToReplace.innerHTML =
        //       this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        //   }));
        // }
      })
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group
    this.selectedSellingPlan = group?.selected_selling_plan
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(id) {
    if (!id) {
      this.selectedSellingPlanGroup = null
      this.selectedSellingPlan = null
      return
    }

    let group = this.availableSellingPlanGroups.find(group => group.selling_plans.find(selling_plan => selling_plan.id == id))
    let selling_plan = group.selling_plans.find(x => x.id == id)

    if (selling_plan) {
      group.selected_selling_plan = selling_plan
      this.selectedSellingPlanGroup = group
      this.selectedSellingPlan = selling_plan
    } else this.log("Error: couldn't find selling plan with id " + id + ' for variant ' + this.selectedVariant.id + ' from product ' + this.product.id + ' : ' + this.product.handle)
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan) return { percent: '0%', amount: 0 }

    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }

  fetchProduct = async handle => {
    let productCache = window.sessionStorage.skioCartProductCache ? JSON.parse(window.sessionStorage.skioCartProductCache) : []
    let cachedProduct = productCache ? productCache.find(product => product.handle == handle) : null

    if (cachedProduct) {
      this.product = cachedProduct
    } else {
      await fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(response => {
          this.product = response
          productCache.push(response)
          window.sessionStorage.skioCartProductCache = JSON.stringify(productCache)
          this.requestUpdate()
        })
    }
  }
}

customElements.define('skio-cart-upsell', SkioCartUpsell)